module.exports = __webpack_public_path__ + "static/img/case-left.994919e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case-left.png
// module id = gxcE
// module chunks = 1